import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { DashboardService } from '../../services/dashboard.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: '',
  template: '',
})
export class IncomeVsExpenseHandler extends BaseSearchComponent<DashboardService> implements OnInit {
  activeCharts: string[] = ['region', 'channel', 'product', 'partner'];
  constructor(
    public service: DashboardService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('incomeVsExpense');
    return header;
  }

  removeChart(chartType: string) {
    this.activeCharts = this.activeCharts.filter((type) => type !== chartType);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.activeCharts, event.previousIndex, event.currentIndex);
  }

  trackByChart(index: number, chart: any) {
    return chart.id || chart.label || index;
  }
}
